import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = { class: "overflow-auto h-100" }
const _hoisted_3 = { class: "chat-messages chat-scroll ps px-2" }
const _hoisted_4 = { href: "javascript:void(0)" }
const _hoisted_5 = { class: "my-1" }
const _hoisted_6 = { class: "clearfix" }
const _hoisted_7 = { class: "input-group d-flex input" }
const _hoisted_8 = {
  key: 1,
  class: "scenario-field-header"
}
const _hoisted_9 = {
  key: 0,
  class: "scenario-field-header"
}
const _hoisted_10 = { class: "card-body chat-area" }
const _hoisted_11 = { href: "javascript:void(0)" }
const _hoisted_12 = { class: "my-1" }
const _hoisted_13 = { class: "clearfix" }
const _hoisted_14 = {
  key: 0,
  class: "align-items-center d-flex flex-column"
}
const _hoisted_15 = {
  key: 1,
  class: "align-items-center d-flex flex-column"
}
const _hoisted_16 = {
  key: 2,
  class: "align-items-center d-flex flex-column"
}
const _hoisted_17 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_18 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_19 = {
  key: 1,
  class: "card-footer"
}
const _hoisted_20 = { class: "" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_image = _resolveComponent("user-image")!
  const _component_modal = _resolveComponent("modal")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.toggle }, undefined, true),
    (!_ctx.staticView)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          modelValue: _ctx.modal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modal) = $event)),
          "slide-out": ""
        }, _createSlots({
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.toTitleCase(_ctx.field)), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "media pb-1 mb-3",
                    key: index
                  }, [
                    (item.user.id!==_ctx.store.getters.user.id)
                      ? (_openBlock(), _createBlock(_component_user_image, {
                          key: 0,
                          source: item.user.image
                        }, null, 8, ["source"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["media-body", item.user.id===_ctx.store.getters.user.id ? 'text-end me-3' : 'ms-3'])
                    }, [
                      _createElementVNode("a", _hoisted_4, _toDisplayString(item.user.name), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(item.content), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-muted small", {'float-start':item.user.id!==_ctx.store.getters.user.id}])
                        }, _toDisplayString(_ctx.moment(item.created_at).fromNow()), 3)
                      ])
                    ], 2),
                    (item.user.id===_ctx.store.getters.user.id)
                      ? (_openBlock(), _createBlock(_component_user_image, {
                          key: 1,
                          source: item.user.image
                        }, null, 8, ["source"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 2
        }, [
          (_ctx.enableCommenting)
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "border-light m-0" }, null, -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.commentModel) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "Type your message"
                    }, null, 512), [
                      [_vModelText, _ctx.commentModel]
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "input-group-append" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary rounded-0"
                      }, "Send")
                    ], -1))
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.classStyle.includes('card-body') && _ctx.staticView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.toTitleCase(_ctx.field)) + " Comments", 1))
      : _createCommentVNode("", true),
    (_ctx.staticView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([_ctx.classStyle, { 'sticky' : _ctx.lockit === true}]),
          id: "lockPosition"
        }, [
          (!_ctx.classStyle.includes('card-body'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.toTitleCase(_ctx.field)) + " Comments", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario?.data?.comments.filter((i)=>i.field === _ctx.field), (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "media pb-1 mb-3",
                key: index
              }, [
                (item.user.id!==_ctx.store.getters.user.id)
                  ? (_openBlock(), _createBlock(_component_user_image, {
                      key: 0,
                      source: item.user.image
                    }, null, 8, ["source"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["media-body", item.user.id===_ctx.store.getters.user.id ? 'text-end me-3' : 'ms-3'])
                }, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(item.user.name), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(item.content), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-muted small", {'float-start':item.user.id!==_ctx.store.getters.user.id}])
                    }, _toDisplayString(_ctx.moment(item.created_at).fromNow()), 3)
                  ])
                ], 2),
                (item.user.id===_ctx.store.getters.user.id)
                  ? (_openBlock(), _createBlock(_component_user_image, {
                      key: 1,
                      source: item.user.image
                    }, null, 8, ["source"]))
                  : _createCommentVNode("", true)
              ])), [
                [_vShow, !_ctx.loading && _ctx.field]
              ])
            }), 128)),
            (_ctx.comments.length === 0 && _ctx.field && _ctx.enableCommenting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[6] || (_cache[6] = [
                  _createElementVNode("h4", { class: "text-secondary" }, "Add a comment below", -1),
                  _createElementVNode("i", { class: "fa fa-comments fa-4x text-muted" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.comments.length === 0 && _ctx.field && !_ctx.enableCommenting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[7] || (_cache[7] = [
                  _createElementVNode("h4", { class: "text-secondary" }, [
                    _createTextVNode("There are no comments for this component. Click one of the green message icons "),
                    _createElementVNode("i", { class: "fas fa-comment-dots text-primary" }),
                    _createTextVNode(" to view comments on a specific section.")
                  ], -1),
                  _createElementVNode("i", { class: "fa fa-comments fa-4x text-muted" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (!_ctx.field)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.scenario.data.reviewer_user_id)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_17, "Select a field to see or make a comment"))
                    : (_openBlock(), _createElementBlock("h4", _hoisted_18, "To start making comments you nedd to click the green button \"Take Scenario Under My Review\".")),
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-comments fa-4x text-muted" }, null, -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.field && _ctx.enableCommenting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "3",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.commentModel) = $event)),
                    placeholder: "Type your message",
                    class: "w-100"
                  }, null, 512), [
                    [_vModelText, _ctx.commentModel]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNote && _ctx.addNote(...args))),
                    disabled: _ctx.loading,
                    type: "button",
                    class: "btn btn-block btn-primary rounded-0"
                  }, "Send", 8, _hoisted_21)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}